/*
 * Converts miles and yards in format:
 * Miles.Yards e.g. 137.0138
 * into miles
 */
const getMilesFromMilesAndYards = (milesAndYards) => {
  const parts = String(milesAndYards).split(".");
  let miles = Number(parts[0]);
  let yards = parts[1] ? Number(parts[1]) : 0;

  miles += yards / 1760;

  return miles;
};

/*
 * Takes two arrays of lat/long and returns the distance between them in miles
 * https://www.geodatasource.com/developers/javascript
 */
const calcDistanceBetweenPointsInMiles = (p1, p2) => {
  if (p1[0] == p2[0] && p1[1] == p2[1]) {
    return 0;
  } else {
    const radlat1 = (Math.PI * p1[0]) / 180;
    const radlat2 = (Math.PI * p2[0]) / 180;
    const theta = p1[1] - p2[1];
    const radtheta = (Math.PI * theta) / 180;
    let dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);

    if (dist > 1) {
      dist = 1;
    }

    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;

    return dist;
  }
};

export default {
  getMilesFromMilesAndYards,
  calcDistanceBetweenPointsInMiles,
};
